import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import Stack from "@mui/material/Stack";

import { CPTCode } from "services/cpt-codes";

export function renderCPTCodeOption(props: object, option: CPTCode) {
  return (
    <ListItem {...props}>
      <Stack direction="row" spacing={2}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            fontSize: 18
          }}
        >
          {option.code}
        </Box>
        <Box sx={{ fontSize: 16, lineHeight: 1.3 }}>{option.description}</Box>
      </Stack>
    </ListItem>
  );
}
